import { AfterViewInit, Component, OnInit } from '@angular/core';
// services
import { StoreService } from './shared/services/state.service';
import { Store } from '@ngrx/store';
import { updateOrderChannels, updateOrganizationName } from './states/actions/setting.action';
import { EnumService } from './shared/services/http/settings/setting.service';
import { IOrderChannel } from './shared/interfaces/setting.interface';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LoadingService } from './shared/services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit {
  enumOrderChannelName: string[];
  previousUrl: string | null = null;
  currentUrl: string | null = null;

  constructor(
    public storeService: StoreService,
    private store: Store,
    private enumService: EnumService,
    public loadingService: LoadingService,
    private router: Router,
    ) {
    this.enumOrderChannelName = ['order_channels', 'organization_name'];
  }
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.loadingStart();
      }
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (this.previousUrl) this.loadingService.setPreviousUrl(this.previousUrl);
        setTimeout(() => {
          this.loadingService.loadingClose();
        }, 200);
      }
    });
  }
  ngAfterViewInit(): void {
    this.storeService.initRetriveStoreData();
    this.getEnumDataByName();
  }

  //get allergies data by name
  private getEnumDataByName() {
    if (!this.enumOrderChannelName) return;

    const $obs = this.enumService.getEnumData({ names: this.enumOrderChannelName }).subscribe({
      next: (value: any) => {
        if (!value.success) return;

        const array: IOrderChannel[] = [];
        for (const prop in value.data[0].data) {
          array.push({ key: prop, value: value.data[0].data[prop] });
        }
        this.store.dispatch(updateOrderChannels({ order_channels: array }));
        this.store.dispatch(updateOrganizationName({ organization_name: value.data[1].data.NAME }));
      },
      error: (err: Error) => {},
      complete: () => {
        $obs.unsubscribe();
      },
    });
  }

}
